//商品
import request from '@/utils/request'

//临时接口，00800
export function searchGoods(storeNo,type){
  let data = {
    url:`http://www.00800.com.cn/cnhs/wqproject/index.php?app=public&mod=Sale&act=search_goods&store_no=${storeNo}&type=${type}`,
  }
  return request({
    url:'http://i-wq.net/online/api/getDatas',
    method:'post',
    data:data
  })
}

export function searchGoodsByType(storeNo,type){
  let data = {
    url:`http://www.00800.com.cn/cnhs/wqproject/index.php?app=public&mod=Sale&act=search_goods_by_type&store_no=${storeNo}&type=${type}`,
  }
  return request({
    url:'http://i-wq.net/online/api/getDatas',
    method:'post',
    data:data
  })
}

export function searchAllGoodByStore(storeNo){
  let data = {
    url:`http://www.00800.com.cn/cnhs/wqproject/index.php?app=public&mod=Sale&act=search_goods_by_type&store_no=${storeNo}`,
  }
  return request({
    url:'http://i-wq.net/online/api/getDatas',
    method:'post',
    data:data
  })
}

export function getGoodDetail(goodNo){
  return request({
    url:`http://192.168.101.115:89/api/goods?no=${goodNo}`,
    method:'get'
  })
}

export function getGoodDesc(url){
  return request({
    url,
    method:'get'
  })
}




// import request from '@/utils/request'

// //临时接口，00800
// export function searchGoods(storeNo,type){
//   return request({
//     url:`http://www.00800.com.cn/cnhs/wqproject/index.php?app=public&mod=Sale&act=search_goods&store_no=${storeNo}&type=${type}`,
//     method:'get'
//   })
// }

// export function searchGoodsByType(storeNo,type){
//   return request({
//     url:`http://www.00800.com.cn//cnhs/wqproject/index.php?app=public&mod=Sale&act=search_goods_by_type&store_no=${storeNo}&type=${type}`,
//     method:'get'
//   })
// }

// export function searchAllGoodByStore(storeNo){
//   return request({
//     url:`http://www.00800.com.cn/cnhs/wqproject/index.php?app=public&mod=Sale&act=search_goods_by_type&store_no=${storeNo}`,
//     method:'get'
//   })
// }

// export function getGoodDetail(goodNo){
//   return request({
//     url:`http://192.168.101.115:89/api/goods?no=${goodNo}`,
//     method:'get'
//   })
// }

// export function getGoodDesc(url){
//   return request({
//     url,
//     method:'get'
//   })
// }